import A from '../../actions/dod/dodDataActions';

export const toggleModalPasswordResetRequest = () => ({ type: A.TOGGLE_PASSWORD_RESET_MODAL });